import "moment/locale/id";
import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { MoneyFormat, upperCase } from "../../libs/index";

function HistoryDetailPage({ props }) {
  const {
    control,
    onModal,
    id,
    data,
    onDownload,
    loadKwi,
    onReport,
    loadReport,
    location,
    onRilis,
    onTransfer,
  } = props;

  /** Status :
   * 0. Belum dibayar
   * 1. Menunggu verifikasi
   * 2. Telah dibayar
   * 3. Gagal dibayar
   * 4. Menunggu hasil
   * 5. Hasil telah keluar
   * */

  return (
    <div className="history-detail">
      <div className="container mx-auto py-6 lg:py-10">
        {/* Ini Adalah Breadcrumb */}
        <div name="breadecrumb" className="flex items-center mb-6 lg:mb-8">
          <p className="m-0 text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-gray">
            Home
          </p>
          <img
            className="mr-3 lg:mr-5"
            src={process.env.REACT_APP_BASE_URL + "/assets/icon/ic_arrow.svg"}
            alt="icon-arrow"
          />
          <p className="m-0 text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-gray">
            Riwayat
          </p>
          <img
            className="mr-3 lg:mr-5"
            src={process.env.REACT_APP_BASE_URL + "/assets/icon/ic_arrow.svg"}
            alt="icon-arrow"
          />
          <p className="m-0 text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-blue">
            {control ? "Detail Pemeriksaan" : "Detail Pembelian"}
          </p>
        </div>

        {/* Mulai Content  */}
        <div className="w-full flex justify-center">
          <div className="detail-wrapper w-full lg:w-3/5 ">
            <div className="p-2 lg:px-12 lg:pt-10">
              <div className="mb-5 lg:mb-6 flex items-center justify-between">
                <p className="header-title-semi text-xl lg:text-3xl colors-blue font-bold ">
                  {control ? "Detail Pemeriksaan" : "Detail Pembelian"}
                </p>
                <div></div>
              </div>
              {/* Header Section */}
              <div className="grid grid-cols-2 grid-rows-1 lg:grid-cols-3 gap-1 lg:gap-5 mb-10 lg:mb-10 items-center">
                <div className="mr-2">
                  <p className="colors-gray mb-1 header-content">
                    Nomor Invoice
                  </p>
                  <div className="flex items-center">
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/icon/ic_invoice.svg"
                      }
                      alt="icon-invoice"
                    />
                    <p className="ml-2 colors-blue font-semibold header-content">
                      {data?.no_invoice ?? "-"}
                    </p>
                  </div>
                </div>
                {control && (
                  <div className="mr-2">
                    <p className="colors-gray mb-1 header-content">Nomor Lab</p>
                    <div className="flex items-center">
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/assets/icon/ic_lab.svg"
                        }
                        alt="icon-lab"
                      />
                      <p className="ml-2 colors-blue font-semibold header-content">
                        {data?.no_lab ?? "-"}
                      </p>
                    </div>
                  </div>
                )}
                {control && (
                  <div className="mr-2 lg:mt-0 mt-3">
                    <p className="colors-gray mb-1 header-content">
                      Tanggal Registrasi
                    </p>
                    <div className="flex items-center">
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          "/assets/icon/ic_date_detail.svg"
                        }
                        alt="icon-date"
                      />
                      <p className="ml-2 colors-blue font-semibold header-content">
                        {moment(data.tgl_registrasi).format(
                          "DD MMM YYYY - HH:mm:ss"
                        )}
                      </p>
                    </div>
                  </div>
                )}
              </div>
              {/* Information Section */}
              <div className="mb-10 lg:mb-10">
                <p className="header-title colors-blue font-semibold text-lg lg:text-2xl mb-3 lg:mb-5">
                  Informasi Pribadi
                </p>
                <div className="flex mb-3 justify-between ">
                  <p className="colors-gray text-sm lg:text-base header-content">
                    Nama Pasien
                  </p>
                  <p className="header-content colors-blue text-sm lg:text-base font-semibold">
                    {upperCase(data?.nama_pasien ?? "")}
                  </p>
                </div>
                <div className="flex mb-3 justify-between ">
                  <p className="colors-gray text-sm lg:text-base header-content">
                    NIK
                  </p>
                  <p className="header-content colors-blue text-sm lg:text-base font-semibold">
                    {data?.nik ?? ""}
                  </p>
                </div>
                <div className="flex mb-3 justify-between ">
                  <p className="colors-gray text-sm lg:text-base header-content">
                    Alamat
                  </p>
                  <p className="w-3/5 text-right header-content colors-blue text-sm lg:text-base font-semibold overflow-ellipsis">
                    {data?.alamat ?? ""}
                  </p>
                </div>
                <div className="flex mb-3 justify-between ">
                  <p className="colors-gray text-sm lg:text-base header-content">
                    Nomor Handphone
                  </p>
                  <p className="header-content colors-blue text-sm lg:text-base font-semibold">
                    {data?.no_telp ?? ""}
                  </p>
                </div>
                <div className="flex mb-3 justify-between ">
                  <p className="colors-gray text-sm lg:text-base header-content">
                    Email
                  </p>
                  <p className="header-content colors-blue text-sm lg:text-base font-semibold">
                    {data?.email ?? ""}
                  </p>
                </div>
              </div>
              {/* Information Pembayaran Section */}
              <div className="mb-10 lg:mb-10">
                <p className="colors-blue font-semibold text-lg lg:text-2xl mb-3 lg:mb-5">
                  Informasi Pembayaran
                </p>
                <div className="flex mb-3 justify-between items-center">
                  <p className="colors-gray text-sm lg:text-base header-content">
                    Status Pembayaran
                  </p>
                  <p
                    className={`${
                      Number(data.status_transaksi) === 0
                        ? "text-red-500"
                        : Number(data.status_transaksi) === 1
                        ? "text-yellow-500"
                        : Number(data.status_transaksi) === 3
                        ? "text-red-700"
                        : "text-green-600"
                    } text-sm lg:text-base font-semibold`}
                  >
                    {data.status_transaksi === 4 &&
                    data.metode_pembayaran === "Bayar di Tempat"
                      ? "Proses Pengambilan"
                      : data.status_transaksi_text}
                  </p>
                </div>
                <div className="flex mb-3 justify-between items-center">
                  <p className="colors-gray text-sm lg:text-base header-content">
                    Metode Pembayaran
                  </p>
                  <p className="header-content colors-blue text-sm lg:text-base font-semibold">
                    {data?.metode_pembayaran ?? ""}
                  </p>
                </div>
              </div>
              {/* Check Payment Section */}
              {data.metode_pembayaran !== "Bayar di Tempat" &&
                (data.status_transaksi === 0 ||
                  data.status_transaksi === 3) && (
                  <div
                    onClick={onTransfer}
                    className="flex cursor-pointer items-center cursor-pointer mb-5"
                  >
                    <button className="btn-white p-3 focus:outline-none w-full ">
                      <div className="colors-blue font-semibold lg:text-lg">
                        Cara Pembayaran
                      </div>
                    </button>
                  </div>
                )}
              {(Number(data.status_transaksi) === 0 ||
                Number(data.status_transaksi) === 3) &&
                data.metode_pembayaran !== "Bayar di Tempat" && (
                  <Link
                    to={`/history/confirmation/${
                      location.pathname.includes("pembelian")
                        ? "pembelian"
                        : "pemeriksaan"
                    }/${id}`}
                  >
                    <button className="btn-blue p-3 focus:outline-none w-full mb-10">
                      <div className="text-white font-semibold lg:text-lg">
                        Klik Disini Untuk <br /> Konfirmasi Pembayaran
                      </div>
                    </button>
                  </Link>
                )}
            </div>
            {(Number(data.status_transaksi) === 0 ||
              Number(data.status_transaksi) === 3) && (
              <div className="bg-blue-full -mx-4 lg:mx-0 mb-10 px-6 lg:px-12 py-5">
                <p className="w-full text-sm lg:w-2/3 text-white lg:text-base">
                  Silahkan tunjukkan bukti berikut kepada petugas loket{" "}
                  {data.metode_pembayaran === "Bayar di Tempat" &&
                    "untuk melakukan pembayaran"}
                </p>
              </div>
            )}
            {(Number(data.status_transaksi) === 0 ||
              Number(data.status_transaksi) === 3) &&
              data.metode_pembayaran === "Bayar di Tempat" && (
                <div className="bg-blue-full -mx-4 lg:mx-0 mb-10 px-6 lg:px-12 py-5">
                  <p className="w-full text-sm lg:w-2/3 text-white lg:text-base">
                    Silahkan tunjukkan bukti berikut kepada petugas loket untuk
                    melakukan pembayaran
                  </p>
                </div>
              )}
            <div className="p-2 lg:px-12 ">
              {/* Information Pemeriksaan Section */}
              <div className="mb-4">
                <p className="colors-blue font-semibold text-lg lg:text-2xl mb-5">
                  {control ? "Informasi Pemeriksaan" : "Informasi Pembelian"}
                </p>

                {data.item_trx &&
                  data.item_trx.map((it, index) => (
                    <div key={index} className="flex">
                      <div className="w-20 h-20 lg:w-28 lg:h-28  mr-4 lg:mr-6  ">
                        <img
                          className="w-20 h-20 lg:w-28 lg:h-28 object-cover rounded-2xl "
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/assets/image/img_empty.png"; // some replacement image
                          }}
                          src={
                            process.env.REACT_APP_BACKEND_URL +
                            "/storage/" +
                            it.image
                          }
                          alt="img-media"
                        />
                      </div>
                      <div className="mb-10 w-2/3 lg:mb-10 ">
                        <p className="colors-gray text-xs lg:text-sm">
                          {control ? "Layanan Kesehatan" : "Media Reagensia"}
                        </p>
                        <p className="colors-blue mt-2 text-md w-2/3 lg:w-full lg:text-lg font-semibold ">
                          {it?.name ?? ""}
                        </p>
                        <p className="colors-orange text-base mb-5 lg:text-lg mt-2 font-semibold ">
                          {"Rp. " + MoneyFormat(Number(it?.harga ?? "0"))}
                        </p>
                        <div className="lg:flex items-center">
                          <div className="mr-0 lg:mr-20">
                            <p className="colors-gray">
                              {control
                                ? "Tanggal Pemeriksaan"
                                : "Tanggal Pengambilan"}
                            </p>
                            <div className="flex items-center mt-1 ">
                              <img
                                src={
                                  process.env.REACT_APP_BASE_URL +
                                  "/assets/icon/ic_date_detail.svg"
                                }
                                alt="icon-date"
                              />
                              <p className="ml-2 colors-blue font-semibold">
                                {moment(it.booking_date).format(
                                  "dddd, DD MMM YYYY"
                                )}
                              </p>
                            </div>
                          </div>
                          {control && (
                            <div className="mr-0 lg:mr-5 mt-3 lg:mt-0">
                              <p className="colors-gray">Waktu Pemeriksaan</p>
                              <div className="flex items-center mt-1 ">
                                <img
                                  src={
                                    process.env.REACT_APP_BASE_URL +
                                    "/assets/icon/ic_time.svg"
                                  }
                                  alt="icon-time"
                                />
                                <p className="ml-2 colors-blue font-semibold">
                                  {it.booking_time} WIB
                                </p>
                              </div>
                            </div>
                          )}
                        </div>
                        {!control && (
                          <div className="lg:flex justify-between mt-5 items-center">
                            <p className="colors-gray">Total Harga</p>
                            <p className="colors-blue text-lg font-semibold">
                              Rp. 1.400.000
                            </p>
                          </div>
                        )}
                      </div>
                      {!control && (
                        <div className="ready lg:ml-10 h-8 w-8 flex justify-center content-center">
                          <p className="colors-green text-sm lg:text-base mt-1">
                            1x
                          </p>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </div>
            <div>
              {/* Gradient Section */}
              {Number(data.status_transaksi) === 5 && (
                <div className="detail-gradient -mx-4 lg:mx-0 mb-10 px-4 lg:px-8">
                  <div className="flex items-center content-center justify-between h-full pl-2  lg:px-5">
                    <p className="colors-blue text-sm lg:text-base font-semibold">
                      {control ? "• Hasil Rilis" : "• Barang Sudah Diambil"}
                    </p>
                    {control ? (
                      <div
                        onClick={onRilis}
                        className="flex cursor-pointer items-center cursor-pointer"
                      >
                        <p className="colors-blue text-sm lg:text-base font-semibold ">
                          Lihat Detail
                        </p>
                        <img
                          className="lg:ml-3"
                          src={
                            process.env.REACT_APP_BASE_URL +
                            "/assets/icon/ic_arrow_homepage.svg"
                          }
                          alt="icon-arrow"
                        />
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              )}
              {Number(data.status_transaksi) === 4 && (
                <div className="detail-gradient -mx-4 lg:mx-0 mb-10 px-4 lg:px-8">
                  <div className="flex items-center content-center justify-between h-full pl-2  lg:px-5">
                    <p className="colors-blue text-sm lg:text-base font-semibold">
                      {control
                        ? "• Menunggu Hasil Rilis"
                        : "• Menunggu Diambil"}
                    </p>

                    <div></div>
                  </div>
                </div>
              )}
              <div className="p-2 lg:px-12 lg:pb-10">
                {/* Review Section */}
                {(Number(data.status_transaksi) === 2 ||
                  Number(data.status_transaksi) === 4 ||
                  Number(data.status_transaksi) === 5) &&
                  data.ulasan && (
                    <div className="grid grid-cols-1 lg:grid-cols-3 grid-rows-1 gap-2 lg:gap-10 mb-10 lg:mb-10">
                      <div className="flex lg:inline">
                        <p className="colors-gray mr-8 lg:mr-0 mb-3">Rating</p>
                        <div>
                          <div className="flex item-center mb-1">
                            <img
                              src={
                                process.env.REACT_APP_BASE_URL +
                                `/assets/icon/${
                                  Number(data.ulasan.rating) >= 1
                                    ? "ic_star_active.svg"
                                    : "ic_star_non.svg"
                                }`
                              }
                              alt="icon-star"
                            />
                            <img
                              src={
                                process.env.REACT_APP_BASE_URL +
                                `/assets/icon/${
                                  Number(data.ulasan.rating) >= 2
                                    ? "ic_star_active.svg"
                                    : "ic_star_non.svg"
                                }`
                              }
                              alt="icon-star"
                            />
                            <img
                              src={
                                process.env.REACT_APP_BASE_URL +
                                `/assets/icon/${
                                  Number(data.ulasan.rating) >= 3
                                    ? "ic_star_active.svg"
                                    : "ic_star_non.svg"
                                }`
                              }
                              alt="icon-star"
                            />
                            <img
                              src={
                                process.env.REACT_APP_BASE_URL +
                                `/assets/icon/${
                                  Number(data.ulasan.rating) >= 4
                                    ? "ic_star_active.svg"
                                    : "ic_star_non.svg"
                                }`
                              }
                              alt="icon-star"
                            />
                            <img
                              src={
                                process.env.REACT_APP_BASE_URL +
                                `/assets/icon/${
                                  Number(data.ulasan.rating) >= 5
                                    ? "ic_star_active.svg"
                                    : "ic_star_non.svg"
                                }`
                              }
                              alt="icon-star-non"
                            />
                          </div>
                          <p className="colors-gray">
                            <b>{data?.ulasan?.rating ?? 0}</b> dari 5 Bintang
                          </p>
                        </div>
                      </div>
                      <div className="lg:col-span-2 flex items-baseline lg:inline">
                        <p className="colors-gray mb-1 mt-4 lg:mt-0 mr-8 lg:mr-0 lg:mb-3">
                          Ulasan
                        </p>
                        <p className="colors-blue">
                          {data?.ulasan?.description ?? "Tidak ada ulasan"}
                        </p>
                      </div>
                    </div>
                  )}
                {/* Button Section */}

                <div className="w-full">
                  {control && Number(data.status_transaksi) === 5 && (
                    <button
                      disabled={loadReport}
                      onClick={onReport}
                      className={`${
                        loadReport ? "btn-loading" : "btn-blue"
                      } p-3 focus:outline-none w-full`}
                    >
                      <p className="text-white font-semibold lg:text-lg">
                        {loadReport ? "Loading" : "Download Hasil"}
                      </p>
                    </button>
                  )}
                  {(Number(data.status_transaksi) === 2 ||
                    Number(data.status_transaksi) === 4 ||
                    Number(data.status_transaksi) === 5) && (
                    <button
                      disabled={loadKwi}
                      onClick={onDownload}
                      className={`${
                        loadKwi ? "btn-loading" : "btn-white-border"
                      } p-3 focus:outline-none w-full my-5`}
                    >
                      <div className="text-white-border font-semibold lg:text-lg">
                        <p className="text-gray-400 lg:text-lg">
                          {loadKwi ? "Loading" : "Download Kwitansi"}
                        </p>
                      </div>
                    </button>
                  )}

                  {(Number(data.status_transaksi) === 2 ||
                    Number(data.status_transaksi) === 4 ||
                    Number(data.status_transaksi) === 5) &&
                    !data.ulasan && (
                      <button
                        onClick={onModal}
                        className="btn-white-border p-3 focus:outline-none w-full "
                      >
                        <div className="text-white-border font-semibold lg:text-lg">
                          <div className="text-gray-400 lg:text-lg">
                            Beri Penilaian Pelayanan
                          </div>
                        </div>
                      </button>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HistoryDetailPage;
